import { Structure } from '@wix/thunderbolt-becky-types'

export type BfsPredicate = (nodeId: string) => boolean

type GetChildren = (nodeId: string) => Array<string> | undefined

export const getChildrenCb: (structure: Structure) => GetChildren = (structure: Structure) => (nodeId) =>
	structure[nodeId]?.components

type BfsArgs = {
	roots: Array<string>
	predicate: BfsPredicate
	getChildren: GetChildren
	shouldStopUponFalsePredicate?: boolean
}

type Bfs = (bfsArgs: BfsArgs) => Record<string, boolean>

export const getComponentDescendantsBfs: Bfs = (bfsArgs) => {
	const { roots, predicate, getChildren, shouldStopUponFalsePredicate } = bfsArgs
	const marks: Record<string, boolean> = {}
	let queue = [...roots]
	while (queue.length > 0) {
		const nodeId = queue.shift()!
		const predicateRes = predicate(nodeId!)
		marks[nodeId] = predicateRes
		const children = getChildren(nodeId!)
		if (!children || (!predicateRes && shouldStopUponFalsePredicate)) {
			continue
		}
		queue = [...queue, ...children]
	}
	return marks
}
